
import React from 'react';
import { Field, reduxForm, Form } from 'redux-form';
import { ReduxInput } from '../ReduxInput';
import {  isRequired, confirm } from '../../components/ReduxInput/Validators';

import { Button, Label, FormGroup } from 'reactstrap';

const AreYouSureForm = (props) => {  
  let { handleSubmit, toggle,  confirmText} = props;
  return (<Form onSubmit={handleSubmit} >
    <FormGroup>
      <Label htmlFor="verification">Please type  <strong>{confirmText}</strong> to confirm</Label>
      <Field        
        type="text"
        id="verification"
        name="verification"
        placeholder={confirmText}
        confirmText={confirmText}
        component={ReduxInput}
        validate={[isRequired, confirm]}
      />
    </FormGroup>
    <Button id="areYouSureSubmit" type="submit" color="primary" >Submit</Button>{' '}
    <Button id="areYouSureCancel"  onClick={toggle}>Cancel</Button>
  </Form >

  );

};

export default reduxForm({
  form: "AreYouSureForm",   // a unique identifier for this form
  destroyOnUnmount: true,         // preserve form data
  forceUnregisterOnUnmount: true,  // unregister fields on unmount
})(AreYouSureForm);





// WEBPACK FOOTER //
// ./src/components/AreYouSure/AreYouSure.js